module.exports = __webpack_public_path__ + "img/banner-logo.53078966.png";